<template>
  <div class="row">
    <div class="col-8 col-md-7 col-sm-12">
      <filters-dashboard-aduanas
        @on-server-filters-change="onServerFiltersChange"
        @on-the-fly-filters-change="onTheFlyFilters = $event"
      />
    </div>
    <div class="col-4 col-md-5 col-sm-12">
      <div style="text-align: right;margin-bottom: 5px;">
      <span>
        Viendo documentos que ingresaron
      </span>
        <span v-if="rangeSelected.valor !== 'personalizado'">
        {{ rangeSelected.nombre }}
      </span>
        <span v-if="rangeSelected.valor === 'personalizado'">
        entre el
          <br>
          <!--<input type="date" class="fecha" v-model="periodoDesde">-->
        <datetime
          v-model="rangeFrom"
          input-class="input-date"
          :phrases="{ok: 'Seleccionar',
           cancel: 'Cancelar'}"
          value-zone="local"
          format="yyyy-MM-dd"
          data-cy="start-time"
        />
        y el
        <datetime
          v-model="rangeUntil"
          input-class="input-date"
          :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
          value-zone="local"
          format="yyyy-MM-dd"
          data-cy="end-time"
        />
        <span>
          <vs-button
            radius
            class="ml-3 d-inline"
            color="primary"
            type="border"
            icon="search"
            size="small"
            @click="changeFilters()"
          />
        </span>
      </span>
        <vs-dropdown vs-trigger-click style="margin-left: 15px">
          <a class="a-icon" href="#">
            Cambiar
            <vs-icon class="" icon="expand_more"></vs-icon>
          </a>
          <vs-dropdown-menu>
            <vs-dropdown-item
              style="width:200px"
              v-for="range in ranges"
              :key="range.valor"
              v-on:click.native="selectRange(range)"
            >
              {{ range.nombre }}
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>
  </div>
</template>
<script>

import FiltersDashboardAduanas from '@/febos/aduanas/dashboard/views/components/FiltersDashboardAduanas';
import { DATE_RANGES } from '@/febos/chile/commons/dateCommons';
import SelectorDateMixin from '@/febos/global/_vue/componentes/filtersLetty/SelectorDateMixin';

export default {
  components: { FiltersDashboardAduanas },
  props: ['value', 'onChange', 'clear'],
  mixins: [SelectorDateMixin],
  data() {
    return {
      onTheFlyFilters: {},
      ranges: DATE_RANGES,
      rangeSelected: { nombre: 'este mes', valor: 'esteMes' },
      rangeFrom: '',
      rangeUntil: '',
      newFilters: '',
      selectFilters: ''
    };
  },
  computed: {
    defaultFilter() {
      return `fechaCreacion:${this.rangeFrom}--${this.rangeUntil}`;
    }
  },
  created() {
    this.rangeFrom = this.$moment().subtract(1, 'month').format('YYYY-MM-DD');
    this.rangeUntil = this.$moment().format('YYYY-MM-DD');
    this.changeFilters();
  },
  methods: {
    onServerFiltersChange(serverFilters) {
      const defaultFilters = `fechaCreacion:${this.rangeFrom}--${this.rangeUntil}`;

      const filters = [
        serverFilters
      ]
        .filter((filter) => !!filter)
        .join('|');

      this.selectFilters = filters;

      const newFilters = filters !== ''
        ? `${defaultFilters}|${filters}`
        : defaultFilters;
      this.currentFilters = newFilters;
      this.onChange(this.currentFilters);
    },
    async changeFilters() {
      const rangeFrom = this.$moment(this.rangeFrom).format('YYYY-MM-DD');
      const rangeUntil = this.$moment(this.rangeUntil).format('YYYY-MM-DD');
      const defaultFilters = `fechaCreacion:${rangeFrom}--${rangeUntil}`;
      const newFilters = this.selectFilters !== ''
        ? `${defaultFilters}|${this.selectFilters}`
        : defaultFilters;
      this.currentFilters = newFilters;
      this.onChange(this.currentFilters);
    },
    clearQueryFilters() {
      // TODO: try to change to default filter state for current view.
      this.$router.go();
    }
  }
};

</script>
<style>
.input-date {
  border: 1px solid #bcbcbc;
  padding: 6px 8px;
  border-radius: 5px;
}
.search-bar {
  align-items: baseline;
  width: 50%;
}
</style>
